if (!customElements.get('bloume-review-slider')) customElements.define('bloume-review-slider', class extends HTMLElement {connectedCallback(){if(this._ready)return;this._ready=true;queueMicrotask(()=>{if(!this.isConnected)return;const scope=this;
  (function () {
    var root = scope.querySelector('[id^="review-slider-"]');
    if (!root) return;
    var track = root.querySelector('[data-track]');
    [].forEach.call(root.querySelectorAll('[data-dir]'), function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-dir'), 10) || 1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  })();
});}disconnectedCallback(){this._resize?.disconnect();}});
if (!customElements.get('bloume-pdp-reviews')) customElements.define('bloume-pdp-reviews', class extends HTMLElement {connectedCallback(){if(this._ready)return;this._ready=true;queueMicrotask(()=>{if(!this.isConnected)return;const scope=this;
  (function () {
    var root = scope.querySelector('[id^="pdp-rv-"]');
    if (!root) return;
    var list = root.querySelector('[data-list]');
    var cards = [].slice.call(list.querySelectorAll('.rv-card'));
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 5;
    var shown = perPage;
    var st = { sort: 'photos', rating: 'all', photos: false };
    var moreBtn = root.querySelector('[data-more]');
    var countEl = root.querySelector('[data-count]');
    var emptyEl = root.querySelector('[data-empty]');
    var baseCount = countEl ? countEl.textContent : '';
    var word = root.getAttribute('data-word') || 'reviews';

    function apply() {
      var sorted = cards.slice().sort(function (a, b) {
        var ia = +a.dataset.index, ib = +b.dataset.index, d = 0;
        if (st.sort === 'photos') d = (+b.dataset.photo) - (+a.dataset.photo);
        else if (st.sort === 'high') d = (+b.dataset.rating) - (+a.dataset.rating);
        else if (st.sort === 'low') d = (+a.dataset.rating) - (+b.dataset.rating);
        return d || ia - ib;
      });
      var matches = 0, vis = 0;
      sorted.forEach(function (c) {
        list.appendChild(c);
        var ok = (st.rating === 'all' || c.dataset.rating === st.rating) && (!st.photos || c.dataset.photo === '1');
        if (ok) {
          matches++;
          if (vis < shown) { c.hidden = false; vis++; } else { c.hidden = true; }
        } else { c.hidden = true; }
      });
      if (moreBtn) moreBtn.hidden = vis >= matches;
      if (emptyEl) emptyEl.hidden = matches > 0;
      if (countEl) countEl.textContent = (st.rating !== 'all' || st.photos) ? matches + ' ' + word : baseCount;
    }

    var sortEl = root.querySelector('[data-sort]');
    var ratingEl = root.querySelector('[data-f-rating]');
    var photosEl = root.querySelector('[data-f-photos]');
    var clearEl = root.querySelector('[data-f-clear]');
    var fBtn = root.querySelector('[data-toggle-filters]');
    var fPanel = root.querySelector('[data-filters]');

    if (sortEl) sortEl.addEventListener('change', function () { st.sort = this.value; shown = perPage; apply(); });
    if (ratingEl) ratingEl.addEventListener('change', function () { st.rating = this.value; shown = perPage; apply(); });
    if (photosEl) photosEl.addEventListener('change', function () { st.photos = this.checked; shown = perPage; apply(); });
    if (clearEl) clearEl.addEventListener('click', function () {
      st.rating = 'all'; st.photos = false;
      if (ratingEl) ratingEl.value = 'all';
      if (photosEl) photosEl.checked = false;
      shown = perPage; apply();
    });
    if (moreBtn) moreBtn.addEventListener('click', function () { shown += perPage; apply(); });
    if (fBtn && fPanel) fBtn.addEventListener('click', function () {
      var open = fPanel.hidden;
      fPanel.hidden = !open;
      fBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    /* Helpful votes: stored per visitor in this browser only. */
    function store(key, val) {
      try { if (val === null) localStorage.removeItem(key); else localStorage.setItem(key, val); } catch (e) {}
    }
    function read(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
    function bump(btn, by) {
      var n = btn.querySelector('[data-n]');
      n.textContent = Math.max(0, (parseInt(n.textContent, 10) || 0) + by);
    }
    cards.forEach(function (card) {
      var cur = read('pdp-rv-vote-' + card.dataset.id);
      if (cur) {
        var b = card.querySelector('[data-vote="' + cur + '"]');
        if (b) { b.setAttribute('aria-pressed', 'true'); bump(b, 1); }
      }
    });
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.rv-vote');
      if (!btn) return;
      var card = btn.closest('.rv-card');
      var key = 'pdp-rv-vote-' + card.dataset.id;
      var dir = btn.getAttribute('data-vote');
      var cur = read(key);
      if (cur === dir) {
        btn.setAttribute('aria-pressed', 'false'); bump(btn, -1); store(key, null);
      } else {
        if (cur) {
          var prev = card.querySelector('[data-vote="' + cur + '"]');
          prev.setAttribute('aria-pressed', 'false'); bump(prev, -1);
        }
        btn.setAttribute('aria-pressed', 'true'); bump(btn, 1); store(key, dir);
      }
    });

    /* Write-a-review modal */
    var dialog = root.querySelector('.rv-modal');
    function openModal() {
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    }
    function closeModal() {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    }
    var openBtn = root.querySelector('[data-open-form]');
    if (openBtn) openBtn.addEventListener('click', openModal);
    if (dialog) {
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('[data-close]')) closeModal();
      });
    }
    /* Photo lightbox */
    var lb = root.querySelector('.rv-lightbox');
    var lbImg = root.querySelector('[data-lb-img]');
    root.addEventListener('click', function (e) {
      var g = e.target.closest('.rv-gallery__item');
      if (!g || !lb) return;
      lbImg.src = g.getAttribute('data-full');
      if (typeof lb.showModal === 'function') lb.showModal(); else lb.setAttribute('open', '');
    });
    if (lb) lb.addEventListener('click', function () {
      if (typeof lb.close === 'function') lb.close(); else lb.removeAttribute('open');
    });

    if (scope.querySelector('[data-auto-open]')) openModal();

    apply();
  })();
});}disconnectedCallback(){this._resize?.disconnect();}});
if (!customElements.get('bloume-photo-carousel')) customElements.define('bloume-photo-carousel', class extends HTMLElement {connectedCallback(){if(this._ready)return;this._ready=true;queueMicrotask(()=>{if(!this.isConnected)return;const scope=this;
  (function () {
    function initSps(scope) {
      var root = scope.querySelector('[data-sps-root]');
      if (!root || root.dataset.spsReady === 'true') return;
      root.dataset.spsReady = 'true';

      var track = root.querySelector('[data-sps-track]');
      var prev = root.querySelector('[data-sps-prev]');
      var next = root.querySelector('[data-sps-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.sps__card');
        if (!card) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function update() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      scope._resize = new ResizeObserver(update); scope._resize.observe(track);
      update();
    }

    initSps(scope);
  })();
});}disconnectedCallback(){this._resize?.disconnect();}});